<form id="register-form" [formGroup]="formGroup" (ngSubmit)="updateItem($event)" class="info-content-container">
  <div id="titleHeader" class="title-header flex-row">
    <span class="flex-1">{{ "hyperlink.admin.createNewItem" | translate }}</span>
    <button class="icon-button icon-close" (click)="goToHyperlinks()"></button>
  </div>
  <div class="scroll-container">
    <div class="content">
      <div class="information-container">
        <div class="statistics-title statistics-title--full">
          {{ "users.main.information" | translate }}
        </div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-3 card-cell">
              <sag-ui-input formControlName="urlLink" [required]="true" [label]="'hyperlink.item.url' | translate" />
            </div>
            <div class="flex-1 card-cell"></div>
          </div>
          @if (isGermanEnabled) {
            <div class="flex-row">
              <div class="flex-3 card-cell">
                <sag-ui-input formControlName="urlLinkDe" [required]="true" [label]="'hyperlink.item.urlDe' | translate" />
              </div>
              <div class="flex-1 card-cell"></div>
            </div>
          }
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <sag-ui-input formControlName="title" [required]="true" [label]="'hyperlink.item.title' | translate" />
            </div>
            @if (isGermanEnabled) {
              <div class="flex-1 card-cell">
                <sag-ui-input formControlName="titleDe" [required]="true" [label]="'hyperlink.item.titleDe' | translate" />
              </div>
            }
          </div>
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <sag-ui-textarea formControlName="description" [label]="'hyperlink.item.description' | translate" />
            </div>
            @if (isGermanEnabled) {
              <div class="flex-1 card-cell">
                <sag-ui-textarea formControlName="descriptionDe" [label]="'hyperlink.item.descriptionDe' | translate" />
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
